import DatePickerInput from "./DatePickerInput.vue";
import { pluginify } from "./../../util";
export default pluginify(DatePickerInput);
export { DatePickerInput };
